import type { ReactNode } from 'react'
import type { PurchasesPackage } from 'react-native-purchases'
import { Pressable, Text, View } from 'react-native'

import { Spinner } from '../../../components/ui/Spinner'
import { colors } from '../../../theme'
import { body2, label1, label2 } from '../../../theme/typography'

export function PurchaseContent({
  isCompactLayout = false,
  isProcessing,
  isPurchasePending,
  onSkip,
  onOpenFirstLegalUrl,
  onOpenSecondLegalUrl,
  onPurchase,
  onVoucherPress,
  optionsContent,
  paymentFirstLegalText,
  paymentLegalAndText,
  paymentLegalPrefixText,
  paymentPrimaryButtonText,
  paymentSecondLegalText,
  purchaseErrorNotice,
  purchaseFeedback,
  selectedPackage,
  skipLabel,
  voucherLabel,
}: {
  isCompactLayout?: boolean
  isProcessing: boolean
  isPurchasePending: boolean
  onSkip: () => void
  onOpenFirstLegalUrl: () => void
  onOpenSecondLegalUrl: () => void
  onPurchase: () => void
  onVoucherPress: () => void
  optionsContent: ReactNode
  paymentFirstLegalText: string
  paymentLegalAndText: string
  paymentLegalPrefixText: string
  paymentPrimaryButtonText: string
  paymentSecondLegalText: string
  purchaseErrorNotice: ReactNode
  purchaseFeedback: { title: string; message: string } | null
  selectedPackage: PurchasesPackage | null
  skipLabel: string
  voucherLabel: string
}) {
  return (
    <>
      {optionsContent}

      <View className={isCompactLayout ? 'mb-2' : 'mb-4'}>
        <Text style={[body2, { color: colors.inkSecondary }]}>
          {paymentLegalPrefixText}{' '}
          <Text
            style={[body2, { color: colors.primary }]}
            className="underline"
            onPress={onOpenFirstLegalUrl}
          >
            {paymentFirstLegalText}
          </Text>{' '}
          {paymentLegalAndText}{' '}
          <Text
            style={[body2, { color: colors.primary }]}
            className="underline"
            onPress={onOpenSecondLegalUrl}
          >
            {paymentSecondLegalText}
          </Text>
        </Text>
      </View>

      <Pressable
        className={`${isCompactLayout ? 'mb-2' : 'mb-4'} self-center`}
        onPress={onVoucherPress}
        testID="e2e-purchase-voucher"
      >
        <Text style={[label2, { color: colors.primary }]} className="underline">
          {voucherLabel}
        </Text>
      </Pressable>

      {purchaseFeedback != null ? purchaseErrorNotice : null}

      <Pressable
        className={`${isCompactLayout ? 'h-10 mb-1' : 'h-12 mb-4'} rounded-lg items-center justify-center ${!selectedPackage || isProcessing ? 'bg-gray-300' : 'bg-primary'} ${isProcessing ? 'opacity-70' : ''}`}
        onPress={onPurchase}
        disabled={!selectedPackage || isProcessing}
        testID="e2e-purchase-submit"
      >
        {isPurchasePending ? (
          <Spinner color="white" />
        ) : (
          <Text style={[label1, { color: colors.primaryForeground }]}>
            {paymentPrimaryButtonText}
          </Text>
        )}
      </Pressable>

      <Pressable
        className={`${isCompactLayout ? 'h-8' : 'h-12'} items-center justify-center`}
        onPress={onSkip}
        disabled={isProcessing}
      >
        <Text style={[label1, { color: colors.inkSecondary }]}>
          {skipLabel}
        </Text>
      </Pressable>
    </>
  )
}
